import { takeLatest, call, put, all } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import {
  AddAdminUserReq,
  LogOutAdmin,
  checkAuthorization,
  getCarsListAdminEditor,
  uploadImgCarId,
  addNewCar,
  deleteCar,
  editCar } from 'api';
import { URLS } from 'config';
import { showLoadScreen, hideLoadScreen } from 'components/LoadScreen/actions';
// import { generateNextRoute } from 'utilz';

import * as actions from './actions';


function* createUserAdmin(user) {
  try {
    yield put(showLoadScreen());
    yield call(AddAdminUserReq, user.payload);
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}

function* checkUserAuthorization() {
  try {
    yield put(showLoadScreen());
    yield call(checkAuthorization);
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}
function* logoutUserAdmin() {
  try {
    yield put(showLoadScreen());
    yield call(LogOutAdmin);
    yield put(hideLoadScreen());
    yield put(push(URLS.LOGINADMIN));
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}
function* getCarsList() {
  try {
    const response = yield call(getCarsListAdminEditor);
    yield put(actions.loadCarList(response.data.list));
  } catch (err) {
    console.log(err);
  }
}

function* uploadImgCar(content) {
  try {
    const { payload: files } = content;
    yield put(showLoadScreen());
    // eslint-disable-next-line
    yield all(Object.keys(files).map(function* (index) {
      const fd = new FormData();
      fd.append('file', files[index]);
      const result = yield call(uploadImgCarId, fd);
      yield put(actions.AddImgUrlToCarData(result.data.url));
      return true;
    }));
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}

function* editPageUploadImgCar(content) {
  try {
    const { payload: files } = content;
    yield put(showLoadScreen());
    // eslint-disable-next-line
    yield all(Object.keys(files).map(function* (index) {
      const fd = new FormData();
      fd.append('file', files[index]);
      const result = yield call(uploadImgCarId, fd);
      yield put(actions.EditAddImgUrlToCarData(result.data.url));
      return true;
    }));
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}

function* editCarReqSend(content) {
  try {
    const { payload: { car } } = content;
    const body = {
      // eslint-disable-next-line
      id: car._id,
      car: JSON.stringify(car)
    };

    yield put(showLoadScreen());
    yield call(editCar, body);
    const response = yield call(getCarsListAdminEditor);
    yield put(actions.loadCarList(response.data.list));
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}
function* addNewCarToDB(content) {
  try {
    const { payload: { car } } = content;
    const body = {
      car: JSON.stringify(car)
    };
    yield put(showLoadScreen());
    yield call(addNewCar, body);
    const response = yield call(getCarsListAdminEditor);
    yield put(actions.loadCarList(response.data.list));
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}

function* deleteCarsFromDB(content) {
  try {
    yield put(showLoadScreen());
    yield content.payload.map(element => call(deleteCar, element));
    const response = yield call(getCarsListAdminEditor);
    yield put(actions.loadCarList(response.data.list));
    yield put(hideLoadScreen());
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}

export default function* () {
  yield takeLatest(
    actions.CREATE_ADMIN_USER,
    createUserAdmin
  );
  yield takeLatest(
    actions.LOGOUT_ADMIN_USER,
    logoutUserAdmin
  );
  yield takeLatest(
    actions.CHECK_AUTHORIZATION,
    checkUserAuthorization
  );
  yield takeLatest(
    actions.GET_CARS_LIST_EDITOR,
    getCarsList
  );
  yield takeLatest(
    actions.UPLOAD_IMG_CAR,
    uploadImgCar
  );
  yield takeLatest(
    actions.ADD_NEW_CAR,
    addNewCarToDB
  );
  yield takeLatest(
    actions.DELETE_CARS,
    deleteCarsFromDB
  );
  yield takeLatest(
    actions.EDIT_UPLOAD_IMG_CAR,
    editPageUploadImgCar
  );
  yield takeLatest(
    actions.EDIT_CAR_REQ,
    editCarReqSend
  );
}



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/saga.js